module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7bb02f9c6e8c77206d09ff672bfaf9ec.png";